import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/off.png'


const _withScopeId = n => (_pushScopeId("data-v-38636ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publish_demand" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tit" }, "基础信息", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tit" }, "方案描述", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tit" }, "经济概算", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("万元")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("万元")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("万元")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tit" }, "其他信息", -1))
const _hoisted_9 = {
  class: "upload_div",
  style: {"border":"none","padding-left":"0","padding-right":"0"}
}
const _hoisted_10 = { class: "tit" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 概念性方案")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最多上传5个文件，单个文件大小不超过100MB", -1))
const _hoisted_13 = { style: {"padding-right":"20px"} }
const _hoisted_14 = { style: {"padding":"0 20px 20px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "fileList_preview_text" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "footer_one" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("暂存")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("提交")

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { publishApi, updatePublishApi, getOffDetailApi } from "@/api/projectDemand"
import { applyApi, getzcDetailApi } from "@/api/resource"
import { dicAPi, uploadApi, msgSecCheckAPi } from "@/api/login"
import commons from "@/utils/commons"
import {
  showSuccessToast,
  showFailToast,
  showLoadingToast,
  closeToast,
  showNotify,
  showImagePreview,
  showToast
} from "vant"
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'applayForm',
  setup(__props) {

const route = useRoute()
const formData: any = ref({
  xqbt: "",
  gnxfaFileSfids: []
})

const showType2 = ref(false)
const fileList = ref([])
const columns = ref([]) //资源类型

const xqlxList2 = ref([
  { text: "否", value: "否" },
  { text: "是", value: "是" }
])
const onConfirmType2 = (e: any) => {
  formData.value.sfqzcyy = e.selectedValues[0]
  // sfqzcyy.value = xqlxList2.value[e.selectedIndexes[0]].text
  showType2.value = false
}
onMounted(() => {
  getAllDict() //获取字典
  if (route.query.id) {
    getDtail(route.query.id)
  }
})
// 获取暂存获取详情
const getDtail = async (id: any) => {
  showLoadingToast({
    message: "加载中"
  })
  getzcDetailApi(id).then((res: any) => {
    closeToast()
    console.log(res)
    if (res.code == 200) {
      formData.value.sqzt = res.data.sqzt
      formData.value.lxr = res.data.lxr
      formData.value.lxdh = res.data.lxdh
      formData.value.sfqzcyy = res.data.sfqzcyy
      formData.value.yyfags = res.data.yyfags
      formData.value.yjztz = res.data.yjztz
      formData.value.yzndsr = res.data.yzndsr
      formData.value.yjndzc = res.data.yjndzc
      formData.value.zcxq = res.data.zcxq
      formData.value.qtwt = res.data.qtwt
      if (res.data.gnxfaFiles) {
        fileList.value = res.data.gnxfaFiles.map((item: any) => {
          return item.fileName
        })
        formData.value.gnxfaFileSfids = res.data.gnxfaFiles.map((item: any) => {
          return item.sfid
        })
      }
      closeToast()
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("resource_type")
  if (res.code == 200) {
    columns.value = res.data
  }
}

// 附件上传
const afterReadFile = (event: any) => {
  showLoadingToast({
    message: "上传中"
  })
  fileList.value.push(event.file?.name)
  const formDatas = new FormData()
  formDatas.append("file", event.file) // 追加文件
  uploadApi(formDatas).then((res: any) => {
    closeToast()
    if (res.code == 200 && res.sucess) {
      formData.value.gnxfaFileSfids.push(res.data.sfid)
      closeToast()
      showNotify({ type: "success", message: "上传成功" })
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 附件删除
const fileRemove = (index: number) => {
  formData.value.gnxfaFileSfids.splice(index, 1)
  fileList.value.splice(index, 1)
}
const onOverSizeFile = (file: any) => {
  showNotify({ type: "warning", message: "单个文件大小不超过100MB" })
}
// 重置
const onReset = () => {
  formData.value = {}
  fileList.value = []
}
// 暂存
const onSave = async () => {
  showLoadingToast({
    message: "暂存中"
  })
  var datas = {
    ...formData.value,
    resourceSfid: route.query.id,
    type: "temp_storage"
  }
  applyApi(datas).then((res: any) => {
    if (res.code == 200) {
      closeToast()
      showNotify({ type: "success", message: "暂存成功" })
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 提交事件
const onSubmit = async () => {
  showLoadingToast({
    message: "提交中"
  })
  var datas = {
    ...formData.value,
    resourceSfid: route.query.id,
    type: "apply"
  }
  applyApi(datas).then((res: any) => {
    if (res.code == 200) {
      closeToast()
      showNotify({ type: "success", message: "提交成功" })
      //   跳转
      router.go(-1)
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_P = _resolveComponent("P")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      class: "van-form"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_van_field, {
          modelValue: formData.value.sqzt,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.sqzt) = $event)),
          name: "申请单位/人",
          label: "申请单位/人",
          class: "requird",
          maxlength: "100",
          placeholder: "请填写单位名称或个人名称",
          clearable: "",
          rules: [{ required: true, message: '请填写申请单位/人' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.lxr,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.lxr) = $event)),
          name: "联系人",
          label: "联系人",
          class: "requird",
          maxlength: "100",
          placeholder: "请填写联系人",
          clearable: "",
          rules: [{ required: true, message: '请填写联系人' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.lxdh,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.lxdh) = $event)),
          name: "联系电话",
          label: "联系电话",
          class: "requird",
          maxlength: "11",
          placeholder: "请填写联系电话",
          clearable: "",
          rules: [
          { required: true, message: '请填写联系电话' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系电话',
            trigger: 'blur'
          }
        ]
        }, null, 8, ["modelValue"]),
        _hoisted_3,
        _createVNode(_component_van_field, {
          readonly: "",
          clickadle: "",
          name: "sfqzcyy",
          modelValue: formData.value.sfqzcyy,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.sfqzcyy) = $event)),
          label: "是否轻资产运营",
          placeholder: "请选择",
          clearable: "",
          "is-link": "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showType2.value = true)),
          class: "set_arrow",
          rules: [{ required: true, message: '请选择' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_popup, {
          show: showType2.value,
          "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showType2).value = $event)),
          position: "bottom",
          style: { width: '100%' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              columns: xqlxList2.value,
              onConfirm: onConfirmType2,
              onCancel: _cache[5] || (_cache[5] = ($event: any) => (showType2.value = false))
            }, null, 8, ["columns"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_field, {
          class: "input_2 requird",
          modelValue: formData.value.yyfags,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.yyfags) = $event)),
          name: "运营方案概述",
          label: "运营方案概述",
          maxlength: "300",
          type: "textarea",
          autoSize: "",
          rows: "3",
          "show-word-limit": "",
          placeholder: "请填写方案说明（可以包含策划理念，主要业态、功能、建设规模、建设周期、商业模式等信息）",
          clearable: "",
          rules: [{ required: true, message: '请填写运营方案概述' }]
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_van_field, {
          modelValue: formData.value.yjztz,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.yjztz) = $event)),
          name: "预计总投资规模",
          label: "预计总投资规模",
          class: "requird",
          placeholder: "请填写预计总投资规模",
          clearable: "",
          rules: [
          { required: true, message: '请填写预计总投资规模' },
          {
            pattern: /^[0-9]*\.?[0-9]+$/,
            message: '请输入数字和小数点',
            trigger: 'blur'
          }
        ]
        }, {
          "right-icon": _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.yzndsr,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.yzndsr) = $event)),
          name: "预计年度运营收益",
          label: "预计年度运营收益",
          class: "requird",
          placeholder: "请填写预计年度运营收益",
          clearable: "",
          rules: [
          { required: true, message: '请填写预计年度运营收益' },
          {
            pattern: /^[0-9]*\.?[0-9]+$/,
            message: '请输入数字和小数点',
            trigger: 'blur'
          }
        ]
        }, {
          "right-icon": _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.yjndzc,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.yjndzc) = $event)),
          name: "预计年度运营支出",
          label: "预计年度运营支出",
          class: "requird",
          placeholder: "请填写预计年度运营支出",
          clearable: "",
          rules: [
          { required: true, message: '请填写预计年度运营支出' },
          {
            pattern: /^[0-9]*\.?[0-9]+$/,
            message: '请输入数字和小数点',
            trigger: 'blur'
          }
        ]
        }, {
          "right-icon": _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _hoisted_8,
        _createVNode(_component_van_field, {
          class: "input_2",
          modelValue: formData.value.zcxq,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.zcxq) = $event)),
          name: "政策需求",
          label: "政策需求",
          maxlength: "300",
          type: "textarea",
          autoSize: "",
          rows: "3",
          "show-word-limit": "",
          clearable: "",
          placeholder: "指当前方案可能遇到的政策阻碍，如公园绿地摆摊需合法化以防被城管驱逐、或需要增容等相关政策需求或突破。"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          class: "input_2",
          modelValue: formData.value.qtwt,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.qtwt) = $event)),
          name: "其他问题",
          label: "其他问题",
          maxlength: "300",
          type: "textarea",
          autoSize: "",
          rows: "3",
          "show-word-limit": "",
          placeholder: "如对当前地块信息有疑问、或需补充的资料、信息等。",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_P, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("i", _hoisted_13, _toDisplayString(fileList.value?.length) + "/5", 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_van_uploader, {
              multiple: "",
              disabled: fileList.value?.length >= 5 ? true : false,
              "max-count": 5,
              "max-size": 100 * 1024 * 1024,
              "preview-image": false,
              accept: ".doc, .docx , .pdf, .ppt,zip, .rar , .excel ",
              "after-read": afterReadFile,
              onOversize: onOverSizeFile,
              "before-read": _unref(commons).beforeReadFile
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_button, {
                  color: "#ffcd01",
                  type: "primary",
                  icon: "plus",
                  class: "upload_files"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled", "before-read"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "fileList_preview",
                onClick: ($event: any) => (_unref(commons).downloadAttachment(formData.value.gnxfaFileSfids[index], item))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(item), 1),
                _createElementVNode("img", {
                  fit: "cover",
                  src: _imports_0,
                  alt: "",
                  onClick: ($event: any) => (fileRemove(index))
                }, null, 8, _hoisted_18)
              ], 8, _hoisted_16))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_van_button, {
            round: "",
            color: "#e6e6e6",
            type: "primary",
            size: "small",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (onReset()))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            round: "",
            color: "#ffcd01",
            plain: "",
            size: "small",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (onSave()))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            round: "",
            color: "#ffcd01",
            type: "primary",
            "native-type": "submit",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})